var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVideoClip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85129 8.66836L21.3471 8.58294C21.8051 8.58294 22.0799 8.92463 22.0799 9.26632V19.7735C22.0799 21.0549 20.9807 22.0799 19.6067 22.0799H4.4925C3.11848 22.0799 2.01927 21.0549 2.01927 19.7735V11.829L1.92767 4.3972C1.83607 3.54297 2.56888 2.77416 3.48489 2.77416L20.1563 1.91992C21.0723 1.91992 21.8051 2.51789 21.8967 3.37212L22.0799 6.6182C22.0799 6.9599 21.8051 7.30159 21.4387 7.30159L3.85129 8.15582V8.66836ZM11.1794 6.10566L13.2862 6.02024L13.561 3.97008L11.4542 4.05551L11.1794 6.10566ZM17.9579 3.79924L15.6678 3.88466L15.393 5.93482L17.6831 5.84939L17.9579 3.79924ZM6.87413 6.27651L9.07256 6.19109L9.34736 4.14093L7.14893 4.22635L6.87413 6.27651ZM19.7899 5.67855H20.1563L20.0647 3.62839L19.7899 5.67855ZM5.04211 4.3972L3.75969 4.48262V6.44736H4.7673L5.04211 4.3972ZM19.1487 20.2861C19.6983 20.2861 20.2479 19.8589 20.2479 19.261V10.6331C20.2479 10.3768 20.0647 10.206 19.7899 10.206L4.4009 10.2914C4.1261 10.2914 3.94289 10.5477 3.94289 10.804V11.7436V19.261C3.94289 19.7735 4.4009 20.2861 5.04211 20.2861H19.1487ZM11.1755 12.6246L14.6577 14.4569C15.1158 14.7068 15.1158 15.2898 14.6577 15.4564L11.1755 17.2887C10.7173 17.5386 10.1675 17.2887 10.1675 16.789V13.1243C10.1675 12.7079 10.7173 12.3747 11.1755 12.6246Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVideoClip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconVideoClip.4a79de7570ab368c9bb6e0cd293ab3b0.svg";